export default class CanalEmailTipoEnum {
    static ImapSmtp = 1
    static Microsoft = 2
}
